/**
 * CostChip.js — Chip for a single cost in the PAY pipeline
 *
 * Shows a summary label in collapsed state.
 * Click to expand for inline editing via ChipExpansionPanel.
 */

import { X } from 'lucide-react';
import { cn } from '../../../../lib/utils';

const getCostLabel = (cost) => {
  if (!cost) return 'cost';
  switch (cost.type) {
    case 'mark_stress':
      return `Mark ${cost.amount || 1} Stress`;
    case 'spend_hope':
      return `Spend ${cost.amount || 1} Hope`;
    case 'spend_token':
      return cost.tokenId
        ? `Spend ${cost.amount || 1} token: ${cost.tokenId}`
        : `Spend token`;
    case 'spend_hp':
      return `Spend ${cost.amount || 1} HP`;
    case 'set_cooldown':
      return cost.cooldownKey
        ? `Cooldown: ${cost.cooldownKey}`
        : 'Set cooldown';
    default:
      return cost.type || 'cost';
  }
};

const CostChip = ({ item, index, isExpanded, onToggleExpand, onRemove, colorScheme }) => (
  <div
    className={cn(
      'inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm cursor-pointer',
      'transition-all',
      colorScheme.chipBg,
      colorScheme.chipText,
      isExpanded && 'ring-1 ring-amber-500'
    )}
  >
    <button
      type="button"
      onClick={() => onToggleExpand(index)}
      aria-expanded={isExpanded}
      aria-label={`Edit cost: ${getCostLabel(item)}`}
      className="select-none text-sm bg-transparent border-0 p-0 cursor-pointer text-inherit"
    >
      {getCostLabel(item)}
    </button>
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onRemove(index); }}
      aria-label={`Remove cost: ${getCostLabel(item)}`}
      className="ml-0.5 hover:text-white transition-colors p-1 min-w-[28px] min-h-[28px] flex items-center justify-center"
    >
      <X size={14} />
    </button>
  </div>
);

export { getCostLabel };
export default CostChip;
